<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Assign via PSL</h4>
      <p>Select a region, project and PSL, then choose the services to assign.</p>
    </div>
    <div class="action-container">
      <button type="button"
              class="btn btn-primary"
              [disabled]="!canAssign"
              (click)="onAssign()"
              data-test="AssignPsl">
        Assign
      </button>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()">
  <div class="landing-main">
    <div class="top-panel" style="width: 100%; display: flex; gap: 12px;">
      <ng-select name="Region"
                 style="flex: 1"
                 bindLabel="RegionName"
                 [(ngModel)]="selectedRegion"
                 (ngModelChange)="onRegionChanged()"
                 placeholder="Select a region"
                 [items]="regions"
                 required
                 data-test="SelectRegion">
      </ng-select>
      <ng-select name="Project"
                 style="flex: 2"
                 bindLabel="Label"
                 [(ngModel)]="selectedProject"
                 (ngModelChange)="onProjectChanged()"
                 placeholder="Select a project"
                 [items]="projects"
                 [disabled]="!selectedRegion"
                 groupBy="PlanTypeLabel"
                 required
                 data-test="SelectProject">
      </ng-select>
      <ng-select name="Psl"
                 style="flex: 1"
                 bindLabel="Label"
                 [(ngModel)]="selectedPsl"
                 (ngModelChange)="onPslChanged()"
                 placeholder="Select a PSL"
                 [items]="pslOptions"
                 [disabled]="!selectedProject"
                 groupBy="Category"
                 required
                 data-test="SelectPsl">
      </ng-select>
    </div>

    <div>
      <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
      <ag-grid-angular #agGrid
                       id="ViewGrid"
                       style="width: 100%; height: 540px"
                       class="ag-theme-balham"
                       [gridOptions]="gridOptions"
                       [rowData]="rowData"
                       [pagination]="true"
                       (gridReady)="onGridReady($event)"
                       (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>

